import type { AdminSupplyChainsResponse } from '@/api/(admin)/supply-chains/types';
import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';

/**
 * Supply chains across all networks, optionally narrowed to one company.
 * Migrated to `/api/admin/supply-chains`, so it takes `API_ROOT_URL`;
 * `apiFetch`'s default base would put `/api-service` in front of the path.
 */
export async function fetchAdminSupplyChains(
  qs: string,
): Promise<AdminSupplyChainsResponse> {
  return apiFetch<AdminSupplyChainsResponse>(
    `/api/admin/supply-chains?${qs}`,
    undefined,
    API_ROOT_URL,
  );
}
